/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Operated_ByInputs */

const fr_vehicle_details_operated_by = /** @type {(inputs: Vehicle_Details_Operated_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opéré par`)
};

const en_vehicle_details_operated_by = /** @type {(inputs: Vehicle_Details_Operated_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operated by`)
};

/**
* | output |
* | --- |
* | "Operated by" |
*
* @param {Vehicle_Details_Operated_ByInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_operated_by = /** @type {((inputs?: Vehicle_Details_Operated_ByInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Operated_ByInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_operated_by(inputs)
	return en_vehicle_details_operated_by(inputs)
});